import { Result, ok, err } from '@xlearn/common';
import { ErrorCode, SchemaError } from '../schema-engine';


export function parseCMIString255(value: string) {
  return parseCMIString(255, value);
}

export function parseCMIString4096(value: string) {
  return parseCMIString(4096, value);
}

export function parseCMIString1000(value: string) {
  return parseCMIString(1000, value);
}

export function parseCMIString64000(value: string) {
  return parseCMIString(64000, value);
}

export function parseCMIString(maxLength: number, value: string): Result<string, SchemaError> {
  if (value.length > maxLength) {
    return err(new SchemaError(
      ErrorCode.incorrectDataType,
      `Length ${value.length} exceeded maximum length ${maxLength}.`));
  }

  return ok(value);
}
